<div class="menu-content">
  <mat-icon style="color: gray; position: absolute; top: 15px; right: 15px; cursor:pointer" (click)="close()">close</mat-icon>
  <div style=" height: 100%;width: 90%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div class="user-image-container">
      <img src="{{imageUrl}}" alt="User Image" class="user-image" />
    </div>
    <p style=" font-weight:400; margin:0 !important" [ngClass]="this._appsService.classes">{{userInfos?.firstName + ' ' + userInfos?.lastName}}</p>
    <p style="font-weight: 300; font-size: 15px; margin:0 !important" [ngClass]="this._appsService.classes">{{'basarsoftTech' | localize }}</p>

    <a style="cursor: pointer; color: #00A1FF; text-decoration: underline; margin:0 !important" (click)="close()" [ngClass]="this._appsService.classes">{{'returnProfile' | localize }}</a>

    <hr class="barely-visible-hr">

  </div>
  <form *ngIf="!isPasswordChanged" [formGroup]="resetPasswordForm" class="reset-password-form" (ngSubmit)="onUpdatePassword()" style="height: 95%; display: flex; justify-content: center; flex-direction: column; width: 100%;" [ngClass]="this._appsService.classes">
    <mat-card-title class="reset-password-mat-card-title" style="font-size:large" [ngClass]="this._appsService.classes">{{'settingPassword' | localize}}</mat-card-title>
  <p class="info-text" style="color: #6c757d; font-size: 13px; margin-top: 10px; margin:0; text-decoration: none;" [ngClass]="this._appsService.classes">{{'passwordText' | localize}}</p>

    <mat-label style="color:black; margin-bottom:5px; font-size:13px;" [ngClass]="this._appsService.classes">{{'currentPassword' | localize}}</mat-label>
    <mat-form-field class="reset-password-element-width login-bg-mat mat-overlay-changed">
      <input matInput
             style="font-size: 13px;"
             [type]="hidePassword ? 'password' : 'text'"
             formControlName="currentPassword"
             placeholder="{{'currentPasswordPh' | localize}}"
             required
             autocomplete="new-password" [ngClass]="this._appsService.classes">
      <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" tabindex="-1" [ngClass]="this._appsService.classes">
        <mat-icon style="color:#585858;">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>

  <mat-error *ngIf="resetPasswordForm.get('currentPassword')?.touched && resetPasswordForm.get('currentPassword')?.hasError('required')" [ngClass]="this._appsService.classes">
      {{'currentPassword' | localize}} <strong>{{'required' | localize}}</strong> {{'field' | localize}}
    </mat-error>
  <mat-error *ngIf="resetPasswordForm.get('currentPassword')?.touched && resetPasswordForm.get('currentPassword')?.hasError('minlength')" [ngClass]="this._appsService.classes">
      {{'currentPassword' | localize}} <strong>{{resetPasswordForm.get('currentPassword')?.errors?.['minlength'].requiredLength }}</strong> {{'charactersLong' | localize}}
    </mat-error>


    <mat-label style="color:black; margin-bottom:5px; margin-top:5px; font-size:13px;" [ngClass]="this._appsService.classes">{{'newPassword' | localize}}</mat-label>
    <mat-form-field class="reset-password-element-width login-bg-mat mat-overlay-changed">
      <input matInput
             style="font-size: 13px;"
             [type]="hideNewPassword ? 'password' : 'text'"
             formControlName="newPassword"
             placeholder="{{'newPasswordPh' | localize}}"
             required
             (input)="onPasswordInput()"
             autocomplete="new-password" [ngClass]="this._appsService.classes" />
      <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword" type="button" tabindex="-1" [ngClass]="this._appsService.classes">
        <mat-icon style="color:#585858;">{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="resetPasswordForm.controls['newPassword'].touched && resetPasswordForm.controls['newPassword'].hasError('required')" [ngClass]="this._appsService.classes">
        {{ 'newPassword' | localize }} <strong>{{ 'required' | localize }}</strong> {{ 'field' | localize }}
      </mat-error>
      <mat-error *ngIf="resetPasswordForm.get('newPassword')?.touched && resetPasswordForm.get('newPassword')?.hasError('pattern') && !resetPasswordForm.get('newPassword')?.hasError('required')" [ngClass]="this._appsService.classes">
        {{'patternMatchPwd' | localize}}
      </mat-error>
    </mat-form-field>
    
    <!-- Şifre Kuralları Bilgilendirme -->
    <div *ngIf="resetPasswordForm.get('newPassword')?.value" [ngClass]="this._appsService.classes" style="margin-top: 5px; margin-bottom: 10px; padding: 8px 10px; background-color: #f5f5f5; border-radius: 4px; width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
      <p [ngClass]="this._appsService.classes" style="margin: 0 0 5px 0; font-weight: 600; color: #333; width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden;">{{'passwordRequirements' | localize}}:</p>
      <ul style="margin: 0; padding-left: 20px; color: #666; width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
        <li [ngClass]="this._appsService.classes" [style.color]="hasMinLength() ? '#4caf50' : '#666'" style="width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
          {{'passwordMinLength' | localize}}
        </li>
        <li [ngClass]="this._appsService.classes" [style.color]="hasUppercase() ? '#4caf50' : '#666'" style="width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
          {{'passwordUppercase' | localize}}
        </li>
        <li [ngClass]="this._appsService.classes" [style.color]="hasLowercase() ? '#4caf50' : '#666'" style="width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
          {{'passwordLowercase' | localize}}
        </li>
        <li [ngClass]="this._appsService.classes" [style.color]="hasNumber() ? '#4caf50' : '#666'" style="width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
          {{'passwordNumber' | localize}}
        </li>
        <li [ngClass]="this._appsService.classes" [style.color]="hasSpecialChar() ? '#4caf50' : '#666'" style="width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; overflow: hidden; box-sizing: border-box;">
          {{'passwordSpecialChar' | localize}}
        </li>
      </ul>
    </div>

    <mat-label style="color:black; margin-bottom:5px; font-size:13px; margin-top:10px;" [ngClass]="this._appsService.classes">{{'newPasswordAgain' | localize}}</mat-label>
    <mat-form-field class="reset-password-element-width login-bg-mat mat-overlay-changed">
      <input matInput
             style="font-size: 13px;"
             [type]="hidePasswordAgain ? 'password' : 'text'"
             formControlName="repeatNewPassword"
             placeholder="{{'newPasswordAgainPh' | localize}}"
             required [ngClass]="this._appsService.classes">
      <button mat-icon-button matSuffix (click)="hidePasswordAgain = !hidePasswordAgain" type="button" tabindex="-1" style="color: black;" [ngClass]="this._appsService.classes">
        <mat-icon style="color:#585858;">{{ hidePasswordAgain ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="resetPasswordForm.controls['repeatNewPassword'].touched && resetPasswordForm.controls['repeatNewPassword'].hasError('required')" [ngClass]="this._appsService.classes">
        {{'newPasswordAgain' | localize}} <strong>{{'required' | localize}}</strong> {{'field' | localize}}
      </mat-error>
      <mat-error *ngIf="resetPasswordForm.get('repeatNewPassword')?.touched && resetPasswordForm.get('repeatNewPassword')?.hasError('pattern') && !resetPasswordForm.get('repeatNewPassword')?.hasError('required')" [ngClass]="this._appsService.classes">
        {{'patternMatchPwd' | localize}}
      </mat-error>
    </mat-form-field>
  <mat-error *ngIf="resetPasswordForm.controls['repeatNewPassword'].touched && resetPasswordForm.controls['repeatNewPassword'].hasError('required')" [ngClass]="this._appsService.classes">
      {{'newPasswordAgain' | localize}} <strong>{{'required' | localize}}</strong> {{'field' | localize}}
    </mat-error>

  <div class="pattern-error" *ngIf="passwordErrorMessage !=null && !isPasswordChanged" [ngClass]="this._appsService.classes">
      {{passwordErrorMessage |localize}}
    </div>
  <mat-error *ngIf="resetPasswordForm.get('repeatNewPassword')?.touched && resetPasswordForm.hasError('passwordsDoNotMatch')" [ngClass]="this._appsService.classes">
      {{'passwordsDoNotMatch' | localize}}
    </mat-error>
    <!--<div style="font-size:8px; color:red;" *ngIf="resetPasswordForm.get('repeatNewPassword')?.hasError('mismatch')">
      {{'passwordsDoNotMatch' | localize}}
    </div>-->


    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column; margin-top: 17px;">
      <button mat-raised-button
              [style.background-color]="isLoading || !resetPasswordForm.valid ? '#D3D3D3' : '#00A1FF'"
              style="width:100%; cursor:pointer; border-radius:7px"
              color="primary"
              type="submit"
              [disabled]="isLoading || !resetPasswordForm.valid" [ngClass]="this._appsService.classes">
        <div style="display: flex; flex-direction: row; justify-content: center;">
          <div style="margin: 5px;">
            <mat-spinner diameter="25" color="primary" *ngIf="isLoading"></mat-spinner>
          </div>
          <span style="margin-left: 5px; color:white;" *ngIf="!isLoading" [ngClass]="this._appsService.classes">{{'resetPassword' | localize}}</span>
        </div>
      </button>
    </div>
  </form>
</div>

<div *ngIf="isPasswordChanged" class="password-success-message">
  <div class="success-container">
    <div class="outer-circle">
      <div class="icon-wrapper">
        <div class="icon-wrapper-inside">
          <mat-icon class="success-icon">check_circle_outline</mat-icon>
        </div>
      </div>
    </div>
    <p class="success-title">{{ 'passwordUpdatedSuccesfully' | localize }}</p>
   <!--  <div style="width: 300px; text-align: center; word-wrap: break-word; overflow-wrap: break-word;">
      <p class="success-description">{{ 'passwordChangedDescription' | localize }}</p>
    </div> -->
  </div>
</div>




